import { fg } from '@atlassian/jira-feature-gating';

const RemoveCtiaqConfigStateRelayProvider = {
	get(): boolean {
		return fg('remove_ctiaq_config_state');
	},
};

export default RemoveCtiaqConfigStateRelayProvider;
